import store from "@/store";
import DataGridHandler from "@/wl-datagrid-handler/dataGridHandler";
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
    data: () => ({
        activeIssue: null,
        activeIndex: 0,
        modal: false,
        headers: [
            {
                text: 'Hμ/νια ',
                value: 'DateCreated',
                filterable: true,
                width: "100"
            },
            {
                text: 'Περιγραφή',
                value: 'IssueTitle',
                filterable: true,
            },
            {
                width: "100",
                text: 'Τύπος Θέματος',
                value: 'IssueTypeDescr'
            },
        ],
        issue: null,

    }),
    watch: {
        openIssues: function () {
            this.setIssues();
        },
        closedIssues: function () {
            this.setClosedIssues();
        }
    },
    beforeCreate() {
        store.registerModule('IssueHandler', DataGridHandler);
        store.registerModule('ClosedIssueHandler', DataGridHandler);
    },
    beforeDestroy() {
        this.$store.unregisterModule('IssueHandler');
        this.$store.unregisterModule('ClosedIssueHandler');
    },
    created() {
        this.showLoading();
        this.setLoadingMessage('Ψάγνουμε για νέα αιτήματα');
        this.getOpenIssues()
            .then(() => {
                this.setIssues();
                this.hideLoading();
            })
    },
    computed: {
        ...mapGetters([
            "openIssues",
            "closedIssues"
        ]),
        ...mapGetters('IssueHandler', [
            "data"
        ]),
        ...mapGetters('ClosedIssueHandler', {
            closedIssuesData: "data"
        })
    },
    methods: {
        ...mapMutations([
            "showLoading",
            "setLoadingMessage",
            "hideLoading"
        ]),
        ...mapMutations('IssueHandler', [
            "clearAllFilters",
            "clearFilter",
            "setData",
            "addFilter",
            "createFilters",

        ]),
        ...mapMutations('ClosedIssueHandler', {
                setClosedFiltersData: "setData",
                createFiltersForClosedIssues: "createFilters",
            }
        ),
        ...mapActions([
            "getOpenIssues",
            "getClosedIssues",
            ]),
        setIssues() {
            this.setData(this.openIssues);
            this.createFilters(
                [
                    {
                        type: 'list',
                        unique: true,
                        key: 'BranchAddress',
                        name: 'Κτήριο'
                    },
                ]
            );
            if (this.$route.query.id) {
                this.issue = null;
                this.activeIssue = this.$route.query.id;
                this.activeIndex = this.openIssues.findIndex(i => i.Issue_ID === this.$route.query.id);
                this.issue = this.openIssues[this.activeIndex];
                this.modal = true;
            } else if (this.activeIssue) {
                const index = this.openIssues.findIndex(i => i.Issue_ID === this.activeIssue)
                if (index !== -1) {
                    this.activeIndex = index;
                    this.issue = this.openIssues[this.activeIndex];
                }
            } else {
                this.modal = false;
                this.issue = this.openIssues[0];
            }
        },
        setClosedIssues() {
            this.setClosedFiltersData(this.closedIssues);
            this.activeIssue = this.closedIssues[0];
            this.activeIndex = 0
            this.createFiltersForClosedIssues(
                [
                    {
                        type: 'combobox',
                        unique: true,
                        key: 'BranchAddress',
                        name: 'Κτήριο'
                    },
                ]
            );
        },
        setIssue(i) {
            this.modal = true;
            this.issue = i;
            this.activeIssue = i.Issue_ID
        },
        resetSelectedClosedIssue() {
            this.modal = false;
            if (this.closedIssues[0]) {
                this.activeIssue = this.closedIssues[0].Issue_ID;
                this.issue = this.closedIssues[0]
            } else {
                this.issue = null;
            }
        },
        resetSelectedOpenIssue() {
            this.modal = false;
            if (this.openIssues[0]) {
                this.activeIssue = this.openIssues[0].Issue_ID;
                this.issue = this.openIssues[0]
            } else {
                this.issue = null;
            }
        }
    }
}
